import moment from 'moment';
import { getData, getTimestampData } from '@/components/report/service';
import { getScanDate } from '@/components/report/service';

import ActualDetail from '@/Entity/ActualDetail';
import DeliveryDisAccordRouteDetail from '@/Entity/DeliveryDisAccordRouteDetail';

import RouteEntity from '@/Entity/RouteEntity';
import GenerateCondit, { IGnerCondit } from '@/models/GenerateCondit';
import { Aggregator, TICKET } from '@/models/GenerateCondit/Interrelated';
import { Result } from '@/Entity/Tools/Result';
import Queryable from '@/Entity/Tools/Queryable';
import { crudRequest } from '@/services/api';
// 获取本周
// const getDate = () => {
//   let weekOfday = parseInt(moment().format('E')) // 计算今天是这周第几天 周日为一周中的第一天
//   let start = moment().subtract(weekOfday - 1, 'days').format("YYYY-MM-DD") // 周一日期
//   let end = moment().add(7 - weekOfday, 'days').format("YYYY-MM-DD")  // 周日日期
//   return {
//     startDate: start,
//     endDate: end
//   }
// }

const getDate = () => {
  // 判断当前时间是否是 是否大于12点
  const dif = moment(moment().format('YYYY-MM-DD 12:00:00')).diff(moment(), 'm');
  if (dif > 0) {
    return [
      moment(
        moment()
          .subtract(1, 'd')
          .format('YYYY-MM-DD 12:00:00'),
      ),
      moment(moment().format('YYYY-MM-DD 12:00:00')),
    ];
  }
  return [
    moment(moment().format('YYYY-MM-DD 12:00:00')),
    moment(
      moment()
        .add(1, 'day')
        .format('YYYY-MM-DD 12:00:00'),
    ),
  ];
};

const params = {
  centerFilter: undefined,
  date: getDate(),
};
export default {
  namespace: 'NotPressRouteTransportGoods',
  state: {
    searchParams: { ...params },
    dataList: [],
    limit: 1,
    pageSize: 20,
  },
  effects: {
    *getData({ payload }, { call, put, select }) {
      crudRequest('/api/route/notPressRouteTransportGoods/search');
      const { searchParams, limit = 1, pageSize, dataList } = yield select(
        ({ NotPressRouteTransportGoods }) => NotPressRouteTransportGoods,
      );
      const {
        provinceArea,
        departureCenter,
        arrivalCenter,
        date,
        productType,
        centerFilter,
      } = searchParams;
      const startMonth = moment(date[0]).format('YYYY-MM-DD HH:mm:ss');
      const endMonth = moment(date[1]).format('YYYY-MM-DD HH:mm:ss');

      const gcTime = new GenerateCondit<DeliveryDisAccordRouteDetail>({
        dataSource: 'delivery_dis_accord_result',
        dimensions: [
          'waybillNo',
          'subBillNo',
          'loadCenter',
          'sendDate',
          '__time',
          'calcWeight',
          'theoryPeriod',
          'actualPeriod',
          'planNextCenter',
          'planRoutePath',
          'actualNextCenter',
          'actualRoutePath',
          'productType',
          'timeDifference',
          'loadWorkerNo',
          'loadWorkerName',
          'originCenter',
          'destCenter',
          'locationMark',
          'loadProvinceArea',
          'actualNextProvinceArea',
        ],
        aggregators: [],
        startDate: startMonth,
        endDate: endMonth,
        queryType: 'scan',
      });

      // 装车营运区
      let loadProvinceAreas = undefined;
      // 装车分拨
      let loadCenters = undefined;
      if (departureCenter && departureCenter.length > 0) {
        if (departureCenter.length == 2) {
          loadCenters = departureCenter.lastItem;
        } else {
          loadProvinceAreas = departureCenter.lastItem;
        }
      }

      // 实际下一站营运区
      let actualNextProvinceAreas = undefined;
      // 实际下一站分拨
      let actualNextCenters = undefined;
      if (arrivalCenter && arrivalCenter.length > 0) {
        if (arrivalCenter.length == 2) {
          actualNextCenters = arrivalCenter.lastItem;
        } else {
          actualNextProvinceAreas = arrivalCenter.lastItem;
        }
      }

      const entityTime = new DeliveryDisAccordRouteDetail({
        loadProvinceArea: loadProvinceAreas,
        loadCenter: loadCenters,
        productType: productType,
        actualNextProvinceArea: actualNextProvinceAreas,
        actualNextCenter: actualNextCenters,
      });
      const conditTime = gcTime.converCondit(entityTime);
      const lim = (payload && payload.limit) || limit;
      const offset = (lim - 1) * pageSize || null;
      const dataTime = yield getScanDate({
        ...conditTime,
        limit: pageSize,
        offset,
      });
      const tempData = dataTime?.map((m, index) => ({
        ids: index + offset,
        ...m,
      }));
      let result = dataList;
      if (lim === 1) {
        result = [];
      }
      Array.prototype.push.apply(result, tempData);
      yield put({
        type: 'update',
        payload: {
          dataList: [].concat(result),
          limit: lim,
        },
      });
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    update(state, { payload }) {
      return { ...state, ...payload };
    },

    updateSearchParams(state, { payload }) {
      return { ...state, searchParams: { ...state.searchParams, ...payload } };
    },
  },
};
